import backBlue1 from  "../assets/Cards/Large/Back Blue 1.png";
import backBlue2 from  "../assets/Cards/Large/Back Blue 2.png";

import backGrey1 from "../assets/Cards/Large/Back Grey 1.png";
import backGrey2 from "../assets/Cards/Large/Back Grey 2.png";

import backRed1 from "../assets/Cards/Large/Back Red 1.png";
import backRed2 from "../assets/Cards/Large/Back Red 2.png";


import clubs1 from  "../assets/Cards/Large/Clubs 1.png";
import clubs2 from  "../assets/Cards/Large/Clubs 2.png";
import clubs3 from  "../assets/Cards/Large/Clubs 3.png";
import clubs4 from  "../assets/Cards/Large/Clubs 4.png";
import clubs5 from  "../assets/Cards/Large/Clubs 5.png";
import clubs6 from  "../assets/Cards/Large/Clubs 6.png";
import clubs7 from  "../assets/Cards/Large/Clubs 7.png";
import clubs8 from  "../assets/Cards/Large/Clubs 8.png";
import clubs9 from  "../assets/Cards/Large/Clubs 9.png";
import clubs10 from  "../assets/Cards/Large/Clubs 10.png";
import clubs11 from  "../assets/Cards/Large/Clubs 11.png";
import clubs12 from  "../assets/Cards/Large/Clubs 12.png";
import clubs13 from  "../assets/Cards/Large/Clubs 13.png";

import diamond1 from  "../assets/Cards/Large/Diamond 1.png";
import diamond2 from  "../assets/Cards/Large/Diamond 2.png";
import diamond3 from  "../assets/Cards/Large/Diamond 3.png";
import diamond4 from  "../assets/Cards/Large/Diamond 4.png";
import diamond5 from  "../assets/Cards/Large/Diamond 5.png";
import diamond6 from  "../assets/Cards/Large/Diamond 6.png";
import diamond7 from  "../assets/Cards/Large/Diamond 7.png";
import diamond8 from  "../assets/Cards/Large/Diamond 8.png";
import diamond9 from  "../assets/Cards/Large/Diamond 9.png";
import diamond10 from  "../assets/Cards/Large/Diamond 10.png";
import diamond11 from  "../assets/Cards/Large/Diamond 11.png";
import diamond12 from  "../assets/Cards/Large/Diamond 12.png";
import diamond13 from  "../assets/Cards/Large/Diamond 13.png";

import spades1 from  "../assets/Cards/Large/Spades 1.png";
import spades2 from  "../assets/Cards/Large/Spades 2.png";
import spades3 from  "../assets/Cards/Large/Spades 3.png";
import spades4 from  "../assets/Cards/Large/Spades 4.png";
import spades5 from  "../assets/Cards/Large/Spades 5.png";
import spades6 from  "../assets/Cards/Large/Spades 6.png";
import spades7 from  "../assets/Cards/Large/Spades 7.png";
import spades8 from  "../assets/Cards/Large/Spades 8.png";
import spades9 from  "../assets/Cards/Large/Spades 9.png";
import spades10 from  "../assets/Cards/Large/Spades 10.png";
import spades11 from  "../assets/Cards/Large/Spades 11.png";
import spades12 from  "../assets/Cards/Large/Spades 12.png";
import spades13 from  "../assets/Cards/Large/Spades 13.png";


import hearts1 from  "../assets/Cards/Large/Hearts 1.png";
import hearts2 from  "../assets/Cards/Large/Hearts 2.png";
import hearts3 from  "../assets/Cards/Large/Hearts 3.png";
import hearts4 from  "../assets/Cards/Large/Hearts 4.png";
import hearts5 from  "../assets/Cards/Large/Hearts 5.png";
import hearts6 from  "../assets/Cards/Large/Hearts 6.png";
import hearts7 from  "../assets/Cards/Large/Hearts 7.png";
import hearts8 from  "../assets/Cards/Large/Hearts 8.png";
import hearts9 from  "../assets/Cards/Large/Hearts 9.png";
import hearts10 from  "../assets/Cards/Large/Hearts 10.png";
import hearts11 from  "../assets/Cards/Large/Hearts 11.png";
import hearts12 from  "../assets/Cards/Large/Hearts 12.png";
import hearts13 from  "../assets/Cards/Large/Hearts 13.png";


const backCardImages = {
    "Red": [backRed1,backRed2],
    "Grey": [backGrey1,backGrey2],
    "Blue": [backBlue1,backBlue2]
}

const allClubs = [
        clubs1,clubs2,clubs3,clubs4,clubs5,clubs6,
        clubs7,clubs8,clubs9,clubs10,clubs11,clubs12,
        clubs13
    ]

const allDiamonds = [
        diamond1,diamond2,diamond3,diamond4,diamond5,diamond6,
        diamond7,diamond8,diamond9,diamond10,diamond11,diamond12,
        diamond13
    ]

const allSpades = [
        spades1,spades2,spades3,spades4,spades5,spades6,
        spades7,spades8,spades9,spades10,spades11,spades12,
        spades13
    ]

const allHearts = [
        hearts1,hearts2,hearts3,hearts4,hearts5,hearts6,
        hearts7,hearts8,hearts9,hearts10,hearts11,hearts12,
        hearts13
    ]


export const getCardBackImage = (color,number) => {

    return backCardImages[color][number-1];

}

export const getCardFrontImage = (rank,suit) => {

    switch(suit){
        case "Diamond":
            return allDiamonds[rank-1];
        case "Clubs":
            return allClubs[rank-1];
        case "Hearts":
            return allHearts[rank-1];
        case "Spades":
            return allSpades[rank-1];
        default:
            break;
    }
}
